import { NgFor, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, InjectionToken } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { DataGridHeaderMenuItem } from 'cloud-shared-lib';

export const HEADER_MENU_DATA = new InjectionToken<DataGridHeaderMenuItem[]>('HEADER_MENU_DATA');

@Component({
  selector: 'csl-data-grid-header-menu',
  templateUrl: './data-grid-header-menu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgFor, NgIf, MatMenuModule, MatIconModule, MatButtonModule],
})
export class DataGridHeaderMenuComponent {
  headerMenu: DataGridHeaderMenuItem[] = [];

  constructor(@Inject(HEADER_MENU_DATA) data: DataGridHeaderMenuItem[]) {
    this.headerMenu = data;
  }

  isVisible(item: DataGridHeaderMenuItem): boolean {
    if (typeof item.visible === 'function') {
      return item.visible();
    }
    return !!item.visible;
  }

  isDisabled(item: DataGridHeaderMenuItem): boolean {
    if (typeof item.disabled === 'function') {
      return item.disabled();
    }
    return !!item.disabled;
  }
}
